import { getAvatarTextInitials } from '@cometchat/calls-sdk-core';
import { memo } from 'react';
import './style.css';

interface AvatarProps {
  name: string;
  imageUrl?: string;
  size?: number;
  fontSize?: number;
}

const Avatar = memo(({ name, imageUrl, size, fontSize }: AvatarProps) => {
  return (
    <div
      className="cometchat-calls-avatar-wrapper"
      style={size ? { width: size, height: size } : {}}>
      {imageUrl ? (
        <img
          src={imageUrl}
          alt={name}
          className="cometchat-calls-avatar-image"
        />
      ) : (
        <div
          className="cometchat-calls-avatar-fallback"
          style={fontSize ? { fontSize } : {}}>
          {getAvatarTextInitials(name)}
        </div>
      )}
    </div>
  );
});

export default Avatar;
